import { Client_Event_Name, } from '@quiz-buzz/common'
import {page_header_style, Standard_Page_Layout, sub_header_style} from '../Components/Standard_Page_Layout'
import { Button } from '../Components/Button'
import { host_machine_actor } from '../App/main'

export function Host_Trial_Ended() {

	const header = (
		<>
			<div className={page_header_style}>Trial game ended</div>
			<div className={sub_header_style}></div>
		</>
	)
	const content = (
		<>
			<h2>coming soon..</h2>
			<ul>
				<li>Buy a game to continue trial</li>
			</ul>
		</>
	)

	const controls = (
		<div className="two_buttons">
			<Button text="Return home" button_style="Primary" onClick={() => host_machine_actor.send({ type: Client_Event_Name.navigate_back })} />
		</div>
	)
	return (
		<Standard_Page_Layout
			header={header}
			content={content}
			controls={controls}
		/>
	)
}


